import { request } from '../../../utils/net/request';
import { getRuntimeModel } from './transforms/getRuntimeModel';
import {
  CancelRequestFunction,
  getAxiosCancelToken,
} from '../../../utils/net/cancel.token';
import { Nullable } from '../../../global/types';
import { setModelProductUrls } from './transforms/setModelProductUrls';
import { RuntimeModel } from '../types';
import { cancellable } from '../../../utils/promise/cancellable';

export interface ProductIdAndUrl {
  id: string;
  url: string;
}

export const getModel = async (
  url: string,
  cancelRequest?: Nullable<CancelRequestFunction>,
  getProductUrlById?: Nullable<(id: string) => Promise<string>>,
): Promise<RuntimeModel> => {
  const cancelToken = cancelRequest
    ? getAxiosCancelToken(cancelRequest)
    : undefined;

  const dtoModel = await request({
    url,
    headers: {
      pragma: 'no-cache',
      'Cache-Control': 'no-cache, no-store',
    },
    ...(cancelToken && { cancelToken }),
  });
  const model = getRuntimeModel(dtoModel);
  const [modelWithUrls, cancelFn] = cancellable(
    setModelProductUrls(model, getProductUrlById),
  );
  if (cancelRequest) {
    cancelRequest(cancelFn);
  }

  return modelWithUrls;
};
